import { createContext, useContext } from 'react';
import {
  QCSFunctions,
  QCUpdatePropFunction,
  FlattenFieldsContextType,
} from '20.formLib/DeclarationContainer/contexts/types';
import { errorHandler } from '80.quickConnect.Core/helpers';

// Tag
const tag = '20.formLib/DeclarationContainer/contexts/index.tsx';

const QCSFunctionsContext = createContext<QCSFunctions | undefined>(undefined);

const QCUpdatePropertyContext = createContext<QCUpdatePropFunction | undefined>(undefined);

export const useQCUpdateFunctionsContext = (): QCUpdatePropFunction | never => {
  const context = useContext(QCUpdatePropertyContext);

  if (!context) {
    const error = new Error('a context of type "QCUpdatePropFunction" must be provided');

    errorHandler(tag, error, 'useQCUpdatePropertyContext');
    throw error;
  }

  return context;
};

export const useQCSFunctions = (): QCSFunctions | never => {
  const context = useContext(QCSFunctionsContext);

  if (!context) {
    const error = new Error(`a context must be provided`);

    errorHandler(tag, error, 'useQCSFunctions');

    throw error;
  }

  return context;
};

export const QCSFunctionsProvider = QCSFunctionsContext.Provider;

export const QCUpdateFunctionsProvider = QCUpdatePropertyContext.Provider;

// FlattenFields Context
export const FlattenFieldsContext = createContext<FlattenFieldsContextType | undefined>(undefined);
export const FlattenFieldsProvider = FlattenFieldsContext.Provider;
export const useFlattenFields = (): FlattenFieldsContextType => {
  const context = useContext(FlattenFieldsContext);
  if (!context) {
    throw new Error('useFlattenFields must be used within a FlattenFieldsProvider');
  }
  return context;
};
